import { FunctionComponentElement, ReactElement, ReactNode } from 'react';

export const isString = (a: unknown): a is string => typeof a === 'string';

export function isReactElement(children: ReactNode): children is ReactElement {
  return (
    children != null &&
    children.hasOwnProperty('type') &&
    children.hasOwnProperty('props')
  );
}

export function isFunctionComponentElement(
  children: ReactNode
): children is FunctionComponentElement<unknown> {
  return isReactElement(children) && children.hasOwnProperty('ref');
}
